import React from 'react';
import { Field,  reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { Radio } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const RescheduleForm = ({ error, handleSubmit, pristine, submitSucceeded, workshopSessions, t }) => {
	let sessions = workshopSessions && workshopSessions.map((session) => {
		return { value: session.id.toString(), label: `${ui.formatDateTime(session.start)} - ${ui.formatTime(session.end)}` }
	});

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<h5>{t('RescheduleSession_SelectNewSession')}</h5>
			<Field name='newSessionId' component={Radio} entries={sessions} horizontal labelCol={1}/>
		</Form>
	);
};

export default reduxForm({ form: 'rescheduleForm' })(withTranslation()(RescheduleForm));
